import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { TicketCreationPanel } from './TicketCreationPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketCreationContext = /*#__PURE__*/createContext(undefined);
export function useTicketCreation() {
  const ctx = useContext(TicketCreationContext);
  if (!ctx) {
    throw new Error('useTicketCreation must be used within TicketCreationProvider');
  }
  return ctx;
}
export function TicketCreationProvider({
  children
}) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const contextValue = useMemo(() => ({
    isOpen,
    open,
    close
  }), [open, close, isOpen]);
  return /*#__PURE__*/_jsxs(TicketCreationContext.Provider, {
    value: contextValue,
    children: [children, isOpen && /*#__PURE__*/_jsx(TicketCreationPanel, {})]
  });
}